import get from 'lodash/get';
// import extend from 'lodash/extend';
import merge from 'lodash/merge';
// import isUndefined from 'lodash/isUndefined';
import identityConfig from '../../../config/identity';
import { canUseDOM } from 'exenv';
import Cookies from 'js-cookie';

export default function datalayer(context) {
  const siteConfig = identityConfig;

  if (siteConfig === undefined) {
    return '';
  }

  const siteSlug = get(siteConfig, 'slug');

  const {
    postData,
    tagPageData,
    categoryPageData,
    // authorPageData,
    // searchPageData,
    staticPageData,
    // mostCreativePeoplePageData,
    // personPageData,
    // statusCode,
    // ibdPageData,
    // companyPageData,
    // micYearPageData,
    // micSectorPageData,
    // videoPageData,
    // productPageData,
    // playlistAllFeedData,
    type
  } = context;

  let category = '';

  // Data layer data default model
  let docTitle = '';
  let windowLocation = '';
  let abGroup = 0;

  if (canUseDOM) {
    docTitle = document.title;
    windowLocation = window.location;
    abGroup = Cookies.get().abgroup;
  }

  let dataLayerMapping = {
    page: {
      category: {
        primaryCategory: 'FastCompany',
        subCategory1: '',
        subCategory2: ''
      },
      pageInfo: {
        pageName: 'fastcompany:missing',
        publisher: 'fast company',
        author: 'fast company',
        authorStatus: '',
        editorName: 'FC Editor',
        pageID: windowLocation.pathname,
        destinationURL: windowLocation.origin + windowLocation.pathname,
        server: 'fc-node',
        urlText: docTitle,
        adPath: '',
        infiniteSrcollIndex: '1',
        pubdate: '1995-11-01',
        daysSincePubdate: Math.round(
          (new Date().getTime() - new Date(`1995-11-01`)) /
            (24 * 60 * 60 * 1000)
        ),
        type: '',
        contentType: '',
        editTags: ''
      }
    },
    user: [
      {
        profile: [
          {
            address: {
              stateProvince: '',
              postalCode: ''
            },
            attributes: {
              isLoggedIn: ''
            },
            profileInfo: {
              profileID: ''
            }
          }
        ],
        segment: {
          abGroup
        }
      }
    ]
  };

  // Homepage Defaults
  dataLayerMapping = merge({}, dataLayerMapping, {
    page: {
      pageInfo: {
        pageName: `${siteSlug}:homepage:front`,
        destinationURL: windowLocation.href,

        adPath: 'mv.fc/homepage/homepage',
        daysSincePubdate: Math.round(
          (new Date().getTime() - new Date(`1995-11-01`)) /
            (24 * 60 * 60 * 1000)
        )
      },
      category: {
        primaryCategory: `homepage`,
        subCategory1: `homepage`,
        subCategory2: `homepage`
      }
    }
  });

  const typeLookup = {
    post() {
      const pageName = postData.title;
      const destinationURL = postData.link;

      let author = '';
      if (postData.author && postData.author.name !== '') {
        author = postData.author.name;
      }

      let primaryCategory = '';
      if (
        postData.categories &&
        postData.categories.length > 0 &&
        postData.categories[0] !== undefined
      ) {
        primaryCategory = postData.categories[0].name;
      }

      let subCategory = '';
      if (
        postData.categories &&
        postData.categories.length > 0 &&
        postData.categories[1] !== undefined
      ) {
        subCategory = postData.categories[1].name;
      } else {
        subCategory = primaryCategory;
      }

      let subSubCategory = '';
      if (
        postData.categories &&
        postData.categories.length > 0 &&
        postData.categories[2] !== undefined
      ) {
        subSubCategory = postData.categories[2].name;
      } else {
        subSubCategory = subCategory;
      }

      let tagString = '';
      tagString = postData.tags.map(tag => tag.name).join(',');

      const pubdate = postData.omnitureDate ? `${postData.omnitureDate}` : '';

      let pageType = 'article';
      if (get(postData, 'posterSlideshow.length')) {
        pageType = 'slideshow';
      } else if (
        get(postData, 'hasVideoPoster') === true ||
        get(postData, 'posterVideo.feedId')
      ) {
        pageType = 'video';
      }

      const urlText = postData.slug.replace(/-/g, ' ');

      let referringURL = '';
      if (canUseDOM) {
        referringURL = document.referrer;
      }

      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName,
            pageID: `fc${postData.id}`,
            destinationURL: `${destinationURL}`,
            referringURL,
            author,
            editorName: 'FC Editor',
            pubdate,
            daysSincePubdate: Math.round(
              (new Date().getTime() - new Date(`${pubdate}`)) /
                (24 * 60 * 60 * 1000)
            ),
            type: pageType,
            publisher: 'fast company',
            server: 'fc-node',
            urlText,
            editTags: tagString,
            infiniteScrollIndex: 1
          },
          category: {
            primaryCategory: `${primaryCategory}`,
            subCategory1: `${subCategory}`,
            subCategory2: `${subSubCategory}`
          }
        }
      });
    },
    page() {
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: `${siteSlug}:page:${get(staticPageData, 'slug')}`,
            destinationURL: `${get(siteConfig, 'url')}/${get(
              staticPageData,
              'slug'
            )}`,
            type: 'page'
          }
        }
      });
    },
    category() {
      category = get(categoryPageData, 'slug', 'news');
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: `${siteSlug}:${category}:front`,
            destinationURL: `${get(siteConfig, 'url')}/${category}`,
            type: 'page'
          },
          category: {
            primaryCategory: `${category}`,
            subCategory1: `${category}`,
            subCategory2: `${category}`
          }
        }
      });
    },
    tag() {
      let tag = '';
      tag = get(tagPageData, 'slug', 'tag');
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: `${siteSlug}:taxonomy:${tag}`,
            destinationURL: `${get(siteConfig, 'url')}/section/${tag}`,
            type: 'collection'
          }
        }
      });
    }
  };

  if (typeLookup[type]) {
    dataLayerMapping = typeLookup[type]();
  }

  return `<script>
      window.digitalData = {
        page: ${JSON.stringify(get(dataLayerMapping, 'page', ''))},
        user: ${JSON.stringify(get(dataLayerMapping, 'user', ''))}
      };
    </script>
    <script src="//assets.adobedtm.com/launch-ENf6f754d17779412f8d246f49c783f295.min.js" async></script>
  `;
}
